<template>
  <div class="send-animation">
    <div class="container">
        <div class="lds-css ng-scope">
            <div style="width:100%;height:100%" class="lds-ellipsis">
                <div>
                    <div>
                    </div>
                </div>
                <div>
                    <div>
                    </div>
                </div>
                <div>
                    <div>
                    </div>
                </div>
                <div>
                    <div>
                    </div>
                </div>
                <div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sendAnimation',
  data () {
    return {}
  },
  computed: {
  }
};
</script>

<style scoped lang="stylus">

@import '../../styles/common.styl'


@keyframes lds-ellipsis3 
  0%, 25%
    left 18px
    transform scale(0)
  50%
    left 18px
    transform scale(1)
  75%
    left 57px
  100%
    left 96px
    transform scale(1)

@keyframes lds-ellipsis2
  0%
    transform scale(1)
  25%, 100%
    transform scale(0)

@keyframes lds-ellipsis
  0%
    left 18px
    transform scale(0)
  25%
    left 18px
    transform scale(1)
  50%
    left 57px
  75%
    left 96px
    transform scale(1)
  100%
    left 96px
    transform scale(0)

.send-animation
  background-repeat no-repeat
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  display flex
  align-items center
  background transparentify($OTSnavBlue, 0.75)
  z-index 1000
  .container
    height 80px
    width 80px
    margin 0 auto
    .lds-ellipsis
        position relative        
        width 80px !important
        height 80px !important
        transform translate(-50%, -50%)
        & > div
            position absolute
            transform translate(-50%, -50%)
            width 18px
            height 18px
        div > div
            width 18px
            height 18px
            border-radius 50%
            background #f00
            position absolute
            top 31px
            left 18px
            animation lds-ellipsis 1.9s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards
        div:nth-child(1) div
            animation lds-ellipsis2 1.9s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards
            background #3b4368
        div:nth-child(2) div
            animation-delay -0.95s
            background #5e6fa3
        div:nth-child(3) div
            animation-delay -0.475s
            background #689cc5
        div:nth-child(4) div
            animation-delay 0s
            background #93dbe9
        div:nth-child(5) div
            animation lds-ellipsis3 1.9s cubic-bezier(0, 0.5, 0.5, 1) infinite forwards
            background #3b4368
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/sendAnimation.vue